import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-connecticut-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./connecticut-state-form.component.html",
  styleUrl: "./connecticut-state-form.component.scss",
})
export class ConnecticutStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
